/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FlightSupportEvent
 */
export interface FlightSupportEvent {
  /**
   * Bounded event family; unknown producer values collapse to "unknown" rather than exposing raw values.
   * @type {string}
   * @memberof FlightSupportEvent
   */
  category: FlightSupportEventCategoryEnum;
  /**
   * Bounded event outcome; unknown producer values collapse to "unknown" rather than exposing raw values.
   * @type {string}
   * @memberof FlightSupportEvent
   */
  status: FlightSupportEventStatusEnum;
  /**
   * Bounded explanation for the event family; this field is never null.
   * @type {string}
   * @memberof FlightSupportEvent
   */
  reason: FlightSupportEventReasonEnum;
  /**
   * Persisted event timestamp in UTC; this field is never null.
   * @type {Date}
   * @memberof FlightSupportEvent
   */
  occurredAt: Date;
}

/**
 * @export
 */
export const FlightSupportEventCategoryEnum = {
  Booking: "booking",
  Payment: "payment",
  SupplierOrder: "supplier_order",
  Ticketing: "ticketing",
  Cancellation: "cancellation",
  Refund: "refund",
  Recovery: "recovery",
  ProviderEvent: "provider_event",
  Unknown: "unknown",
} as const;
export type FlightSupportEventCategoryEnum =
  (typeof FlightSupportEventCategoryEnum)[keyof typeof FlightSupportEventCategoryEnum];

/**
 * @export
 */
export const FlightSupportEventStatusEnum = {
  Pending: "pending",
  Succeeded: "succeeded",
  Failed: "failed",
  NeedsAttention: "needs_attention",
  PartiallyTicketed: "partially_ticketed",
  Cancelled: "cancelled",
  Refunded: "refunded",
  PartiallyRefunded: "partially_refunded",
  Unknown: "unknown",
} as const;
export type FlightSupportEventStatusEnum =
  (typeof FlightSupportEventStatusEnum)[keyof typeof FlightSupportEventStatusEnum];

/**
 * @export
 */
export const FlightSupportEventReasonEnum = {
  BookingStateChanged: "booking_state_changed",
  PaymentStateChanged: "payment_state_changed",
  SupplierOrderStateChanged: "supplier_order_state_changed",
  TicketingStateChanged: "ticketing_state_changed",
  CancellationStateChanged: "cancellation_state_changed",
  RefundStateChanged: "refund_state_changed",
  RecoveryStateChanged: "recovery_state_changed",
  ProviderEventProcessed: "provider_event_processed",
  FlightItineraryChanged: "flight_itinerary_changed",
  FlightChangeRequiresAssistance: "flight_change_requires_assistance",
  ProviderReconciliationContradiction: "provider_reconciliation_contradiction",
  ProviderReconciliationApplied: "provider_reconciliation_applied",
  ProviderReconciliationEvidenceMerged:
    "provider_reconciliation_evidence_merged",
  ProviderReconciliationNoChange: "provider_reconciliation_no_change",
  ProviderServicingApplied: "provider_servicing_applied",
  ProviderServicingPending: "provider_servicing_pending",
  ProviderCancellationRecoveryRequired:
    "provider_cancellation_recovery_required",
  ProviderPaymentDivergence: "provider_payment_divergence",
  ProviderStatusIgnored: "provider_status_ignored",
  CustomerRefundAwaitingApproval: "customer_refund_awaiting_approval",
  TicketSettlementPreparationFailed: "ticket_settlement_preparation_failed",
  BookingRecoveryClaimed: "booking_recovery_claimed",
  BookingRecoveryDeferred: "booking_recovery_deferred",
  BookingRecoveryCompleted: "booking_recovery_completed",
  CompatibilityUnknown: "compatibility_unknown",
} as const;
export type FlightSupportEventReasonEnum =
  (typeof FlightSupportEventReasonEnum)[keyof typeof FlightSupportEventReasonEnum];

/**
 * Check if a given object implements the FlightSupportEvent interface.
 */
export function instanceOfFlightSupportEvent(
  value: object
): value is FlightSupportEvent {
  if (!("category" in value) || value["category"] === undefined) return false;
  if (!("status" in value) || value["status"] === undefined) return false;
  if (!("reason" in value) || value["reason"] === undefined) return false;
  if (!("occurredAt" in value) || value["occurredAt"] === undefined)
    return false;
  return true;
}

export function FlightSupportEventFromJSON(json: any): FlightSupportEvent {
  return FlightSupportEventFromJSONTyped(json, false);
}

export function FlightSupportEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FlightSupportEvent {
  if (json == null) {
    return json;
  }
  return {
    category: json["category"],
    status: json["status"],
    reason: json["reason"],
    occurredAt: new Date(json["occurred_at"]),
  };
}

export function FlightSupportEventToJSON(json: any): FlightSupportEvent {
  return FlightSupportEventToJSONTyped(json, false);
}

export function FlightSupportEventToJSONTyped(
  value?: FlightSupportEvent | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    category: value["category"],
    status: value["status"],
    reason: value["reason"],
    occurred_at: value["occurredAt"].toISOString(),
  };
}
